import React, { memo } from 'react'
import map from 'lodash/map'
import { Redirect, Route, Switch } from 'react-router-dom'
import SecureRoute from './SecureRoute'
import SecureRouteAnyPermission from './SecureRouteAnyPermission'
import PropTypes from 'prop-types'
import { getPaths } from './utils'

function RouteLoader({ routes, prefix, notfoundRedirect, hasAnyPermission }) {
  return (
    <Switch>
      {map(routes, ({ path, ...route }, key) => {
        return !hasAnyPermission ? (
          <SecureRoute
            key={key}
            {...route}
            path={getPaths(prefix, path)}
            notfoundRedirect={notfoundRedirect}
          />
        ) : (
          <SecureRouteAnyPermission
            key={key}
            {...route}
            notfoundRedirect={notfoundRedirect}
            path={getPaths(prefix, path)}
          />
        )
      })}
      {notfoundRedirect && (
        <Route
          path='*'
          name='page_no_found'
          component={() => <Redirect to={notfoundRedirect} />}
        />
      )}
    </Switch>
  )
}

export default memo(RouteLoader)

RouteLoader.propTypes = {
  hasAnyPermission: PropTypes.bool,
  notfoundRedirect: PropTypes.string,
  prefix: PropTypes.string,
  routes: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}
